import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-modal-generic-header',
  templateUrl: './modal-generic-header.component.html',
  styleUrls: ['./modal-generic-header.component.scss'],
})
export class ModalGenericHeaderComponent  implements OnInit {

  @Input() header: string = '';
  @Output() closeClicked = new EventEmitter<void>();

  constructor() { }

  ngOnInit() {
    return
  }

}
